import "./style/bundle-section-cta.scss"

import React from "react"
import { CampaignPageNavigator } from "./types/CampaignAdminTypes"
import AppLink from "@modules/shared/AppLink"
import { FiChevronRight } from "@ng-mw/reol/icon-components/FiChevronRight"
import Button from "@ng-mw/reol/components/Button"
import illustrationShoppingCart from "@resources/icons/illustration-shopping-cart"
import Icon from "@ng-mw/reol/components/Icon"

interface BundleSectionCTAProps {
    campaignPageNavigator: CampaignPageNavigator
}

const BundleSectionCTA = ({ campaignPageNavigator }: BundleSectionCTAProps) => {
    const to = `/savings/campaigns/campaign-${campaignPageNavigator.id.join("-")}`
    const state = {
        ...campaignPageNavigator,
    }

    return (
        <div className="bundle-section-cta">
            <Icon
                className="bundle-section-cta__icon"
                icon={illustrationShoppingCart}
                size={{ width: "120px", height: "120px" }}
            ></Icon>
            <p className="bundle-section-cta__text">Nysgjerrig på resten av produktene?</p>
            <AppLink
                to={to}
                state={state}
            >
                <Button>
                    Se alle <FiChevronRight />
                </Button>
            </AppLink>
        </div>
    )
}

export default BundleSectionCTA
